import type { TableFilterData } from '@/types/Base';
import type { AlterCode } from '@/types/Materials';
import { axios } from './axiosClient';
import { validate } from '@/utils/errors/helpers';
import { getAlterCodesWithConditionsSchema } from '@/types/schemas/alterCodes/getAlterCodesWithConditions';

export async function getAlterCodesWithConditions({
  page = 1,
  itemsPerPage = 0,
  query,
  sortColumn,
  sortAscending,
  groupItemId,
}: TableFilterData & { groupItemId?: string }): Promise<{ data: AlterCode[]; count: number }> {
  const skip = (page - 1) * itemsPerPage;
  const response = await axios.post(`/v2/alterCodes/search?take=${itemsPerPage}&skip=${skip}`, {
    searchText: query,
    sortColumn,
    sortAscending,
    groupItemId,
  });

  const valid = validate(getAlterCodesWithConditionsSchema, response.data.data);
  return { data: valid, count: response.data.count };
}
